import axios from "@/config/axios";

const state = {
  labSquireOrderTestTubesInfo: null,
};

const getters = {
  getLabSquireOrderTestTubesInfo: (state) => state.labSquireOrderTestTubesInfo,
};

const actions = {
  fetchLabSquireOrderTestTubesInfo: async ({ commit }, payload) => {
    try {
      const response = await axios.post("order-case/tube-info", payload);
      commit("setLabSquireOrderTestTubesInfo", response.data);
      return response.data; 
    } catch (error) {
      console.error("API Error in fetchLabSquireOrderTestTubesInfo:", error.response || error.message);
      commit("setLabSquireOrderTestTubesInfo", null);
      throw error; 
    }
  },
};
const mutations = {
  setLabSquireOrderTestTubesInfo(state, data) {
    state.labSquireOrderTestTubesInfo = data;
  },
  RESET_LAB_SQUIRE_INFO(state) {
    state.labSquireOrderTestTubesInfo = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
